import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useLocation, useNavigate } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from '@mui/material/Button';
import Snackbar from "@mui/material/Snackbar";
import Clear from "@mui/icons-material/Clear";
import { Link } from "react-router-dom";
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import moment from "moment";
import InfiniteScroll from "react-infinite-scroller";
import { setCache } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";

const FavoriteLocationList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const [loading, setLoading] = useState(false);
  const [currentFavId, setcurrentFavId] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [orderBy, setOrderBy] = useState("CreatedDate");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [sortByCreatedDate, setSortByCreatedDate] = useState(false);
  const [sortByAddress, setSortByAddress] = useState(false);
  const [favList, setFavList] = useState([]);

  const handleSortingByCreatedDate = (orderby, orderdirection) => {
    setFavList([]);
    setPage(1); // Reset page when sorting changes
    setSortByCreatedDate(!sortByCreatedDate);
    setOrderBy(orderby);
    setOrderDirection(orderdirection);
  };

  const handleSortingByAddress = (orderby, orderdirection) => {
    setFavList([]);
    setPage(1); // Reset page when sorting changes
    setSortByAddress(!sortByAddress);
    setOrderBy(orderby);
    setOrderDirection(orderdirection);
  }

  const handleClickOpen = (favorite) => {
    setcurrentFavId(favorite.id);
    setOpenDialog(true);
  };

  const handleClickClose = () => {
    setOpenDialog(false);
  };

  const fetchFavoritesList = (reset = false) => {
    if (reset) {
      setFavList([]);
      setPage(1);
    }
    setLoading(true);
 let inputData={ page,
        resultsPerPage: rowsPerPage,
        orderBy,
        orderDirection,
        userId: 0,}
        apiCommonTrigger("post",`${Config.API_URL}/maps/favorites`,inputData)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setFavList(prevList => [...prevList, ...res.data.favorites]);
          setTotalPages(res.data.pagination?.totalpages || 1);
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
        setLoading(false);
      });
  };

  useEffect(() => {  
    fetchFavoritesList();
  }, [orderBy, orderDirection, page, rowsPerPage]);

  const handleDeleteFavorite = () => {
    setLoading(true);
    apiCommonTrigger("delete" , Config.API_URL + "/maps/address/favorite/" , [currentFavId])
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setOpenDialog(false);
          setSnackOpen({ snackOpen: true, snackMsg: "Favorite removed successfully!" });
          fetchFavoritesList(true); // Refresh the list after deletion
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
        setLoading(false);
      });
  };

  const snackHandleclose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ snackOpen: false, snackMsg: "" });
  };

  const handleInfiniteOnLoad = () => {
    if (page + 1 <= totalPages) {
      setPage(page + 1);
    }
  };

  return (
    <div className="common-table fav-locations">
      {loading && (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      )}
      
      <InfiniteScroll
        initialLoad={false}
        loadMore={handleInfiniteOnLoad}
        hasMore={page <= totalPages}
        threshold={20}
      >
        <h2>Favorite Locations</h2>
        <div className="my-markets-table fav_table">
          <TableContainer component={Paper} style={{ overflowX: "initial" }} className="table-design">
            <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {sortByAddress ? (
                      <span
                        onClick={() => handleSortingByAddress("Address", "DESC")}
                        style={{ cursor: "pointer", fontWeight: orderBy === "Address" ? "bold" : "" }}
                      >
                        Address <ArrowDownwardOutlinedIcon fontSize="small" />
                      </span>
                    ) : (
                      <span
                        onClick={() => handleSortingByAddress("Address", "ASC")}
                        style={{ cursor: "pointer", fontWeight: orderBy === "Address" ? "bold" : "" }}
                      >
                        Address <ArrowUpwardOutlinedIcon fontSize="small" />
                      </span>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {sortByCreatedDate ? (
                      <span
                        onClick={() => handleSortingByCreatedDate("CreatedDate", "DESC")}
                        style={{ cursor: "pointer", fontWeight: orderBy === "CreatedDate" ? "bold" : "" }}
                      >
                        Created Date <ArrowDownwardOutlinedIcon fontSize="small" />
                      </span>
                    ) : (
                      <span
                        onClick={() => handleSortingByCreatedDate("CreatedDate", "ASC")}
                        style={{ cursor: "pointer", fontWeight: orderBy === "CreatedDate" ? "bold" : "" }}
                      >
                        Created Date <ArrowUpwardOutlinedIcon fontSize="small" />
                      </span>
                    )}
                  </TableCell>
                  <TableCell align="left">View</TableCell>
                  <TableCell align="left">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {favList.length > 0 ? (
                  favList.map((favorite) => (
                    <TableRow key={favorite.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell align="left">
                        {favorite.address ? favorite.address : "-"}
                      </TableCell>
                      <TableCell align="left">
                        {favorite.createddate
                          ? moment(favorite.createddate).format("DD-MMM-YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell align="left">
                        <Button
                         className="nav_link" onClick={async()=>{
                                             await setCache("market-search",  { prevPath: location.pathname, id: favorite.id, favorite });
                                             navigate("/market-search")
                                            }}
                          // state={{ prevPath: location.pathname, id: favorite.id, favorite }}
                        >
                          View on Map
                        </Button>
                      </TableCell>
                      <TableCell align="left" className="three-dots">
                        <MenuItem onClick={() => handleClickOpen(favorite)} className="delete-option">
                          <DeleteOutlinedIcon />
                        </MenuItem>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }} colSpan="4" className="store-no-data">
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snack.snackOpen}
          autoHideDuration={5000}
          onClose={snackHandleclose}
          message={snack.snackMsg}
          action={[
            <Clear key="close" aria-label="Close" color="inherit" onClick={snackHandleclose} />,
          ]}
        />

        <Dialog open={openDialog} onClose={handleClickClose} className="small-info-popup">
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to delete?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClickClose} className="no-btn">
              No
            </Button>
            <Button onClick={handleDeleteFavorite} className="yes-btn">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </InfiniteScroll>
    </div>
  );
};

export default FavoriteLocationList;
